import { webConfig } from '@blockit/web-shared/config/webConfig';
import { Attribution } from '@blockit/web-shared/utils/attribution';
import { initAmplitude } from '@features/analytics/utils/initAmplitude';
import { RescheduleTokenStore } from '@features/blockit-link/rescheduleTokenStore';
import { initRum } from '@lib/rum';
import React from 'react';
import ReactDom from 'react-dom/client';

import { App } from '@/App';

// Must run before RUM (and later Amplitude and the router) read the location: the public
// reschedule URL carries a credential in its query string.
RescheduleTokenStore.stashFromUrl();

// After the stash, so a reschedule URL's credential is already out of `location`. `buildTouch`
// keeps only allowlisted params and never the raw query string, so this ordering is defence in
// depth rather than the only thing standing between a secret and the attribution cookie.
Attribution.capture();

initRum(webConfig.datadogRum);
initAmplitude();

ReactDom.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
